import Vue from "vue"
import errImg from "@/assets/img/no_goods.png";
/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function (url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true) {
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
};

// 单独作用于应用模块的管理
// 传的是错误的图片
Vue.directive('err-img', async function (el) {
    let realURL = el.src;
    if(realURL){
        let exist = await imageIsExist(realURL);
        if (!exist) {
            el.setAttribute('src', errImg);
        }
    }
    else {
        el.setAttribute('src', errImg);
    }
});
